import React, { Component } from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {situarImagen} from "../js/actions/index";
import "./situar.scss";
import caso from "../caso";

function mapStateToProps(state){
	return{
		abordajeActual:state.exploracion.abordajeActual,
		casoActual:state.exploracion.casoActual,
	};
}
function mapDispatchToProps(dispatch){
	return {
		situarImagen: (imagen,tipo) => dispatch(situarImagen({tipo:tipo,valor:imagen})),
	};
}
class Situar extends Component{
	state={seleccionada:-1};
	randomOrder = [];
	reset(){
		this.randomOrder = [];
		let aux = [];
		for(let i = 0; i<this.props.valores.opciones.length; i++)aux.push(i);
		while(aux.length > 0){
			let index = Math.floor(Math.random()*aux.length);
			let indexRandom = aux.splice(index,1);
			this.randomOrder = this.randomOrder.concat(indexRandom);
		}
		this.setState({seleccionada:-1});
	}
	UNSAFE_componentWillMount(){
		this.reset();
	}
	UNSAFE_componentWillReceiveProps(){
		this.reset();
	}
	render(){
		this.abordaje = caso[this.props.casoActual].abordajes[this.props.abordajeActual];
		let listaImagenes = this.randomOrder.map((index)=>{
			let item = this.props.valores.opciones[index];
			let divStyle ={backgroundImage:"url('content/"+this.props.baseURL+"/"+item+"')"};
			let clase = "imgSituar";
			if(this.state.seleccionada === index)clase += " on";
			return <div className={clase} key={index} style={divStyle} onClick={()=>{
				if(index === this.props.valores.valida) this.props.situarImagen(item,this.props.baseURL);
				else this.setState({seleccionada:index});
			}}/>;
		});
		return(
			
			<section id="menuSituar">
				<h1>{this.props.titulo}</h1>
				<h2>{this.props.caso}</h2>
				<h3>{this.props.abordaje}</h3>
				<p><b>Ecografista:</b> {this.abordaje.situar.titulo}</p>
				<p><b>Paciente:</b> {this.abordaje.anatomia.titulo}</p>
				<p><b>Ejercicio:</b> {this.abordaje.ejercicio}</p>
				<div className="listaSituar">{listaImagenes}</div>
				<div className="instruccion">{this.props.instruccion}</div>
			</section>
		);
	}
}

Situar.propTypes = {
	abordajeActual:PropTypes.number,
	casoActual:PropTypes.number,
	situarImagen:PropTypes.func,
	instruccion:PropTypes.string,
	titulo:PropTypes.string,
	cabecera:PropTypes.string,
	caso:PropTypes.string,
	abordaje:PropTypes.string,
	valores:PropTypes.object,
	baseURL:PropTypes.string,
};

export default connect(mapStateToProps,mapDispatchToProps)(Situar);